import { render, staticRenderFns } from "./articlemanagehouseadd.vue?vue&type=template&id=28b1efbf&scoped=true&"
import script from "./articlemanagehouseadd.vue?vue&type=script&lang=js&"
export * from "./articlemanagehouseadd.vue?vue&type=script&lang=js&"
import style0 from "./articlemanagehouseadd.vue?vue&type=style&index=0&id=28b1efbf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1efbf",
  null
  
)

component.options.__file = "articlemanagehouseadd.vue"
export default component.exports